<template>
    <a-modal v-model="visible" title="成果资料明细" width="67%" centered :maskClosable="false" :keyboard="false" class="diyModelCls">
        <a-spin :spinning="loading">
            <vxe-table
                ref="itemTable"
                size="mini"
                resizable
                keep-source
                auto-resize
                row-id="id"
                align="left"
                header-align="center"
                highlight-hover-row
                show-overflow="tooltip"
                :data="editItemData"
                :edit-config="{ trigger: 'click', mode: 'row', showStatus: true, showIcon: false }"
            >
                <vxe-table-column type="seq" title="序号" width="70" align="center"> </vxe-table-column>
                <vxe-table-column field="zlmc" title="资料名称" width="300"></vxe-table-column>
                <vxe-table-column field="bz" title="备注" min-width="100"></vxe-table-column>
                <vxe-table-column title="附件" width="150" align="center">
                    <template v-slot="scope">
                        <span class="btn_edit" @click="attachShow(scope.row)">相关资料</span>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-spin>
        <template v-slot:footer>
            <a-button @click="onClose" style="margin-right:8px;">
                取消
            </a-button>
        </template>
        <AttachModalDownload :attachCfg.sync="attachProps" />
    </a-modal>
</template>

<script>
export default {
    name: "ZlmxForm",
    props: ["showZlmxEdit", "dataId", "cgsbbmxid"],
    data() {
        return {
            // 避免重复点击提交
            saving: false,
            // 编辑数据
            editData: {},
            editItemData: [],
            editDataLoading: false,
            editProps: {
                showZlmxEdit: false,
                cgsbbmxid: null
            },
            attachProps: {
                visible: false,
                fkvalue: null,
                fktable: "CG_CGSBBMX_ZLMX",
                fkfield: "ID",
                attachSource: "CG1001"
            }
        };
    },
    computed: {
        visible: {
            get() {
                return this.showZlmxEdit;
            },
            set(newVal) {
                this.$emit("update:showZlmxEdit", newVal);
            }
        },
        loading() {
            return this.editDataLoading;
        }
    },
    watch: {
        visible: {
            handler(newVal) {
                // 显示编辑窗口时加载数据
                if (newVal) {
                    // 修改，加载数据
                    this.loadItemData();
                }
            },
            immediate: true
        }
    },
    methods: {
        loadItemData() {
            this.editItemData = [];
            this.editItemDataLoading = true;
            this.$FG_http
                .post(
                    "./api/main/zxcggl/cgsbgl/listItemZlmx",
                    {
                        cgsbbmxid: this.cgsbbmxid,
                        sort: {
                            field: "XH",
                            order: "asc"
                        }
                    },
                    {
                        showSuccess: false
                    }
                )
                .then(({ success, data, errMsg }) => {
                    this.editItemDataLoading = false;
                    if (success) {
                        this.editItemData = data.data;
                    } else {
                        // 加载数据出错则返回列表
                        this.editIsVisible = false;
                    }
                });
        },
        // 取消
        onClose(e) {
            this.visible = false;
        },
        // 附件管理
        attachShow(row) {
            // 设置编辑记录id
            this.attachProps.fkvalue = row.id;
            // 显示编辑窗口
            this.attachProps.visible = true;
        }
    }
};
</script>
